<!-- Top dark bar (NOT fixed) -->
<div class="top-bar">
  <nav class="top-nav container">
    <!-- Right: links + search -->
    <ul class="links" aria-label="Top navigation">
      @for (item of headerMenu; track item.name) {
      <li>
        <button class="link" type="button" (click)="opendPage(item)">
          {{ item.name }}
        </button>
      </li>
      }
    </ul>
  </nav>
</div>

<!-- Secondary white bar (STICKY) -->
<div class="secondary-bar">
  <div class="container secondary-content">
    <div class="brand">
      <a
        href="/index.html"
        class="logo"
        title="Loup Logistics Homepage"
        style="border-bottom: 0; padding-top: 5px"
      >
        <img
          src="https://www.louplogistics.com/images/logo.png"
          alt="Loup Logistics"
          class="logo-img"
        />
      </a>
    </div>

    <ul class="sections">
      <li class="has-submenu">
        <up-button class="section" button-style="text"
          >What we do
          <up-menu (menuItemSelected)="onItemDetail($event)">
            @for (entry of whatWeDo; track $index) {
            <up-menu-item [itemDetail]="entry">
              {{ entry.name }}
            </up-menu-item>
            }
          </up-menu>
        </up-button>
      </li>
      <li class="has-submenu">
        <up-button class="section" button-style="text" aria-haspopup="true"
          >Solutions
          <up-menu (menuItemSelected)="onItemDetail($event)">
            @for (entry of solutions; track $index) {
            <up-menu-item [itemDetail]="entry">
              {{ entry.name }}
            </up-menu-item>
            }
          </up-menu>
        </up-button>
      </li>
      <li class="has-submenu">
        <up-button class="section" button-style="text" aria-haspopup="true"
          >Resource Center
          <up-menu (menuItemSelected)="onItemDetail($event)">
            @for (entry of resourceCenter; track $index) {
            <up-menu-item [itemDetail]="entry">
              {{ entry.name }}
            </up-menu-item>
            }
          </up-menu>
        </up-button>
      </li>
      <li>
        <button
          class="section"
          type="button"
          (click)="openExternal('/suppliers.html')"
        >
          SUPPLIERS
        </button>
      </li>
      <li>
        <button
          class="section"
          type="button"
          (click)="openExternal('/news/announcements.html')"
        >
          ANNOUNCEMENTS
        </button>
      </li>
      <li>
        <button
          class="section"
          type="button"
          (click)="openExternal('/connect.html')"
        >
          CONNECT WITH US
        </button>
      </li>
    </ul>
  </div>
</div>
